/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { useIntl } from 'react-intl';
import { KTSVG } from '../../../../helpers';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { SidebarMenuItem } from './SidebarMenuItem';
import { useAuth } from 'src/app/modules/auth';

const SidebarMenuMain = () => {
  const intl = useIntl();
  const { currentUser, logout } = useAuth();

  const permissions = currentUser?.permissions

  return (
    <>
      <SidebarMenuItem to='/dashboard' replace={true} icon='/media/icons/duotune/art/art002.svg' title={'Trang chủ'} fontIcon='bi-app-indicator' />

      {permissions?.includes("Permissions.HoSo.Manage") && (
        <SidebarMenuItemWithSub to='/admin/quan-ly-ho-so' title='Quản lý hồ sơ' icon='/media/icons/duotune/files/fil012.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/admin/quan-ly-ho-so/ho-so' title='Hồ sơ' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/gui-duyet' title='Gửi duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/da-duyet' title='Đã duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/tu-choi' title='Từ chối' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/cho-tieu-huy' title='Chờ tiêu hủy' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/da-tieu-huy' title='Đã tiêu hủy' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/bao-mat' title='Báo mất' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-ho-so/danh-muc-ho-so' title='Danh mục hồ sơ' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {permissions?.includes("Permissions.TaiLieu.Manage") && (
        <SidebarMenuItemWithSub to='/admin/quan-ly-tai-lieu' title='Quản lý tài liệu' icon='/media/icons/duotune/files/fil003.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/tai-lieu' title='Tài liệu' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/gui-duyet' title='Gửi duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/da-duyet' title='Đã duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/tu-choi' title='Từ chối' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/cho-tieu-huy' title='Chờ tiêu hủy' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/da-tieu-huy' title='Đã tiêu hủy' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/bao-mat' title='Báo mất' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-tai-lieu/danh-muc-tai-lieu' title='Danh mục tài liệu' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {permissions?.includes("Permissions.MuonTra.Manage") && (
        <SidebarMenuItemWithSub to='/admin/quan-ly-muon-tra' title='Quản lý đăng ký mượn' icon='/media/icons/duotune/files/fil011.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/admin/quan-ly-muon-tra/phieu-muon' title='Phiếu mượn' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-muon-tra/da-duyet' title='Phiếu mượn đã duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-muon-tra/huy-duyet' title='Phiếu mượn hủy duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/quan-ly-muon-tra/lich-su-tra' title='Lịch sử trả' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {/* {permissions?.includes("Permissions.TaiLieuMinhChung.Manage") && ( */}
      <SidebarMenuItemWithSub to='/admin/tai-lieu-minh-chung' title='Tài liệu minh chứng' icon='/media/icons/duotune/files/fil008.svg' fontIcon='bi-person'>
        {/* <SidebarMenuItem to='/admin/tai-lieu-minh-chung/tai-lieu' title='Tài liệu' hasBullet={true} /> */}

        {permissions?.includes("Permissions.TaiLieuMinhChungQuanLy.Manage") &&
          (<SidebarMenuItem to='/admin/tai-lieu-minh-chung/quan-ly' title='Quản lý' hasBullet={true} />)
        }

        {permissions?.includes("Permissions.TaiLieuMinhChungTongHop.Manage") &&
          (<SidebarMenuItem to='/admin/tai-lieu-minh-chung/tong-hop' title='Tổng hợp' hasBullet={true} />)
        }

        {permissions?.includes("Permissions.TaiLieuMinhChungChoYKien.Manage") &&
          (<SidebarMenuItem to='/admin/tai-lieu-minh-chung/cho-y-kien' title='Cho ý kiến' hasBullet={true} />)
        }
        {permissions?.includes("Permissions.TaiLieuMinhChungDanhMuc.Manage") &&
          <SidebarMenuItem to='/admin/tai-lieu-minh-chung/loai-tai-lieu' title='Loại tài liệu' hasBullet={true} />
        }
      </SidebarMenuItemWithSub>
      {/* )} */}
      {permissions?.includes("Permissions.BaoCao.Manage") && (
        <SidebarMenuItemWithSub to='/admin/bao-cao' title='Thống kê, theo dõi' icon='/media/icons/duotune/graphs/gra001.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/admin/bao-cao/tinh-trang-tai-lieu' title='Tình trạng tài liệu' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/hieu-suat-nhan-vien' title='Hiệu suất nhân viên' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/qua-trinh-chuyen-doi' title='Quá trình chuyển đổi' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/so-luong-tai-lieu-ho-so' title='Số lượng tài liệu hồ sơ' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/dang-soan' title='Số lượng tài liệu hồ sơ đang soạn' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/cho-xem-xet' title='Số lượng tài liệu hồ sơ chờ xem xét' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/cho-duyet' title='Số lượng tài liệu hồ sơ chờ duyệt' hasBullet={true} />
          <SidebarMenuItem to='/admin/bao-cao/cham' title='Số lượng tài liệu hồ sơ chậm' hasBullet={true} />

        </SidebarMenuItemWithSub>

      )}
      {permissions?.includes("Permissions.DanhMuc.Manage") && (
        <SidebarMenuItemWithSub to='/admin/danh-muc' title='Danh mục' icon='/media/icons/duotune/files/fil001.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/admin/danh-muc/quy-trinh' title='Quy trình' hasBullet={true} />
          <SidebarMenuItem to='/admin/danh-muc/ban-hanh-quy-trinh' title='Ban hành quy trình' hasBullet={true} />

          <SidebarMenuItem to='/admin/danh-muc/tieu-chi-danh-gia' title='Tiêu chí đánh giá' hasBullet={true} />
          <SidebarMenuItem to='/admin/danh-muc/cong-bo-phu-hop' title='Công bố phù hợp' hasBullet={true} />
          <SidebarMenuItem to='/admin/danh-muc/luu-do' title='Lưu đồ' hasBullet={true} />
          <SidebarMenuItem to='/admin/danh-muc/thiet-lap-bieu-mau' title='Thiết lập biểu mẫu' hasBullet={true} />
          <SidebarMenuItem to='/admin/danh-muc/ho-so-ma-chung-minh' title='Hồ sơ mã chứng minh' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {permissions?.includes("Permissions.HeThong.Manage") && (
        <SidebarMenuItemWithSub to='/admin/he-thong' title='Hệ thống' fontIcon='bi-sticky' icon='/media/icons/duotune/coding/cod001.svg'>
          <SidebarMenuItem to='/admin/he-thong/co-cau' title='Cơ cấu tổ chức' hasBullet={true} />
          <SidebarMenuItem to='/admin/he-thong/nguoi-dung' title='Người dùng' hasBullet={true} />
          <SidebarMenuItem to='/admin/he-thong/chuc-vu' title='Chức vụ' hasBullet={true} />
          {/* <SidebarMenuItem to='/admin/he-thong/vai-tro' title='Vai trò' hasBullet={true} /> */}
          <SidebarMenuItem to='/admin/he-thong/thong-tin-dinh-dang' title='Thông tin định dạng dữ liệu' hasBullet={true} />
          <SidebarMenuItem to='/admin/he-thong/duy-tri-cai-tien-he-thong' title='Duy trì cải tiến hệ thống' hasBullet={true} />
          <SidebarMenuItem to='/admin/he-thong/chinh-sach-chat-luong' title='Chính sách chất lượng' hasBullet={true} />
          <SidebarMenuItem to='/admin/he-thong/muc-tieu-chat-luong' title='Mục tiêu chất lượng' hasBullet={true} />

          <SidebarMenuItem to='/admin/he-thong/nhat-ky-hoat-dong' title='Nhật ký hoạt động' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}

    </>
  );
};

export { SidebarMenuMain };
